import React from 'react'
//import Lines from '../lines/Lines';
//import FAQ from '../faq/FAQ'; 
//import About from '../about/About';
import { Helmet } from 'react-helmet-async';
import {constants} from "../core/data/constants";
import Hero from '../hero/Hero';
import Pricing from '../pricing/Pricing';
//import Clients from '../clientsCarouesel/Clients';
import ClientsManual from '../clientsCarouesel/ClientsManual';
import PricingInfo from '../pricing/PricingInfo';
import Info from '../info/Info';
import Banner from '../info/Banner';
import Lines from '../info/Lines';
import CTA from '../info/CTA';

const SITIOWEBURL = constants[0].URL;
const WEBSITE = constants[0].websiteName;
const CONTENT = constants[0].mainContent;
const href = `${SITIOWEBURL}`;
//const metaTITLE = constants[0].metaTitle; 
//const metaCONTENT = constants[0].metaDescription;
//const metaURL = constants[0].metaURL


const Home = () => {
    return (
        <div>
            <Helmet>
                <title>{WEBSITE}</title>
                <meta name="description" content={CONTENT} />
                <link rel='canonical' href={href}/>
            </Helmet>
            <main className=''>
                <div id="home">
                    <Hero/>
                </div>
                <div>
                    <ClientsManual/>
                </div>
                <div>
                <Lines/>
                  <Info/>
                </div>
                <div id="pricing">
                    <Pricing/>
                </div>
                <div id="contact">
                    <CTA/>
                </div>
                
            </main>
        </div>
    )
}

export default Home